module.exports = __webpack_public_path__ + "static/media/cnpsta.65690499.jpg";